import styled from 'styled-components';
import { themeContract } from '../../ProductCare.theme.contract';
var PolicyLink = styled.a.withConfig({
  displayName: "ProductCareFooterstyles__PolicyLink",
  componentId: "sc-1eorw03-0"
})(["display:inline-block;width:100%;font-weight:", ";color:", ";text-decoration:underline;"], function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.color.palette[themeContract[props.theme.channel].policyLink.color];
});
var CheckboxContainer = styled.div.withConfig({
  displayName: "ProductCareFooterstyles__CheckboxContainer",
  componentId: "sc-1eorw03-1"
})(["margin:10px 0;border-radius:3px;padding:0;background-color:", ";"], function (props) {
  return props.theme.color.semantic.info.lighter;
});
export { PolicyLink, CheckboxContainer };